module.exports = __webpack_public_path__ + "static/media/jobbier-BN.569bd105.svg";